<div #curveTopContainer class="top-container">
  <svg viewBox="0 0 800 75" class="svg" preserveAspectRatio="none">
    <path #curveTop [attr.fill]="backgroundColor" d="M 800 50 Q 400 -50 0 50 Z"></path>
    <rect [attr.fill]="backgroundColor" y="50" width="100%" height="25" shape-rendering="crispEdges" />
  </svg>
</div>
<ng-content></ng-content>
<div *ngIf="!disableBottomAnimation" #curveBottomContainer class="bottom-container">
  <svg viewBox="0 0 800 75" class="svg" preserveAspectRatio="none">
    <defs>
      <mask [id]="maskId">
        <rect fill="#fff" width="100%" height="25" shape-rendering="crispEdges" />
        <path #curveBottom fill="#fff" d="M 800 25 Q 400 125 0 25 Z"></path>
      </mask>
    </defs>

    <rect [attr.fill]="backgroundColor" width="100%" height="100%" [attr.mask]="'url(#' + maskId + ')'" />
  </svg>
</div>
